import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Pipeline2vw6c5wpzxajt as Pipeline } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/Pipeline.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpResponseContainerClass;
function HttpResponseContainer() {
  if (HttpResponseContainerClass === VOID) {
    class $ {
      constructor(expectedType, response) {
        this.x5k_1 = expectedType;
        this.y5k_1 = response;
      }
      we() {
        return this.x5k_1;
      }
      xe() {
        return this.y5k_1;
      }
      toString() {
        return 'HttpResponseContainer(expectedType=' + this.x5k_1.toString() + ', response=' + toString(this.y5k_1) + ')';
      }
      hashCode() {
        var result = this.x5k_1.hashCode();
        result = imul(result, 31) + hashCode(this.y5k_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpResponseContainer()))
          return false;
        if (!this.x5k_1.equals(other.x5k_1))
          return false;
        if (!equals(this.y5k_1, other.y5k_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpResponseContainer');
    HttpResponseContainerClass = $;
  }
  return HttpResponseContainerClass;
}
var PhasesClass;
function Phases() {
  if (PhasesClass === VOID) {
    class $ {
      constructor() {
        Phases_instance = this;
        this.z5n_1 = new (PipelinePhase())('Before');
        this.a5o_1 = new (PipelinePhase())('State');
        this.b5o_1 = new (PipelinePhase())('After');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass = $;
  }
  return PhasesClass;
}
var Phases_instance;
function Phases_getInstance() {
  if (Phases_instance === VOID)
    new (Phases())();
  return Phases_instance;
}
var HttpReceivePipelineClass;
function HttpReceivePipeline() {
  if (HttpReceivePipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance().z5n_1, Phases_getInstance().a5o_1, Phases_getInstance().b5o_1]);
        this.y5z_1 = developmentMode;
      }
      m4s() {
        return this.y5z_1;
      }
    }
    initMetadataForClass($, 'HttpReceivePipeline', HttpReceivePipeline, VOID, VOID, [2]);
    HttpReceivePipelineClass = $;
  }
  return HttpReceivePipelineClass;
}
var PhasesClass_0;
function Phases_0() {
  if (PhasesClass_0 === VOID) {
    class $ {
      constructor() {
        Phases_instance_0 = this;
        this.q5i_1 = new (PipelinePhase())('Receive');
        this.r5i_1 = new (PipelinePhase())('Parse');
        this.s5i_1 = new (PipelinePhase())('Transform');
        this.t5i_1 = new (PipelinePhase())('State');
        this.u5i_1 = new (PipelinePhase())('After');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass_0 = $;
  }
  return PhasesClass_0;
}
var Phases_instance_0;
function Phases_getInstance_0() {
  if (Phases_instance_0 === VOID)
    new (Phases_0())();
  return Phases_instance_0;
}
var HttpResponsePipelineClass;
function HttpResponsePipeline() {
  if (HttpResponsePipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance_0();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance_0().q5i_1, Phases_getInstance_0().r5i_1, Phases_getInstance_0().s5i_1, Phases_getInstance_0().t5i_1, Phases_getInstance_0().u5i_1]);
        this.g60_1 = developmentMode;
      }
      m4s() {
        return this.g60_1;
      }
    }
    initMetadataForClass($, 'HttpResponsePipeline', HttpResponsePipeline, VOID, VOID, [2]);
    HttpResponsePipelineClass = $;
  }
  return HttpResponsePipelineClass;
}
//region block: exports
export {
  Phases_getInstance as Phases_getInstance3nx89wd8botnl,
  Phases_getInstance_0 as Phases_getInstance1ydmp5ct4mzr8,
  HttpReceivePipeline as HttpReceivePipeline1ousblrss634z,
  HttpResponseContainer as HttpResponseContainer3r9yzy4mwwvc9,
  HttpResponsePipeline as HttpResponsePipeline14ucx7kbf4hm2,
};
//endregion

//# sourceMappingURL=HttpResponsePipeline.mjs.map
